  // src/firebase.js
	// import firebase from 'firebase/app';
	import { initializeApp } from 'firebase/app';
	import { getAuth } from 'firebase/auth'; // If you're using Firebase Authentication
	import { getFirestore } from 'firebase/firestore'; // If you're using Firestore
	import { getMessaging, getToken, onMessage } from 'firebase/messaging';
	
	const firebaseConfig = {
        apiKey: "AIzaSyBoHb0wgfxHR20BPunMGZlxgxXyBoY33DI",
		authDomain: "hr-beetronix.firebaseapp.com",
		projectId: "hr-beetronix",
		storageBucket: "hr-beetronix.firebasestorage.app",
		messagingSenderId: "214797265239",
		appId: "1:214797265239:web:3d3fa2ef5b93bf14117612"
   	};
	// Initialize Firebase
	const app = initializeApp(firebaseConfig);
	const auth = getAuth(app);
	const firestore = getFirestore(app); 

	export { auth, firestore };

	// Initialize Firebase Cloud Messaging
	const messaging = getMessaging(app);

	// Request permission and get token
	export const requestForToken = async () => {
		try {
			const token = await getToken(messaging, { vapidKey:'BIJydbHtw2uXJhm8YjC5zlrB6ej8aEQ9DJWwtr-tLHOrM5oD7D6ldicjeZCcACFlDN23avfGThovzSgFNqDhdmU' });
			console.log('Token:', token);
			console.log(token)
			return token;
		} catch (error) {
			console.error('Error getting token:');
		}
	};

	// Handle incoming messages
	onMessage(messaging, (payload) => {
		console.log('Message received. ', payload);
		// Customize notification handling here
	});

	export { messaging };
	// Exporting the Firebase services you need

   
